export class NICEDNCGroup {
    dncGroupId: number;
    dncGroupName: string;
    dncGroupDescription: string;
    isActive: string;
    isRemoved: boolean;
    lastUpdateTime: string;
    createDate: string;
    totalGroups: number;
    defaultBUdnc: boolean;
    validRecords: number;

    constructor(dncJSON?: any) {
        let createDateFormat;
        if (dncJSON) {
            this.validRecords = dncJSON.validRecords + 0;
            this.totalGroups = dncJSON.totalGroups || 0;
            this.dncGroupId = dncJSON.dncGroupId || 0;
            this.dncGroupName = dncJSON.dncGroupName || '';
            this.defaultBUdnc = this.dncGroupName === 'Business Unit Do Not Call';
            this.dncGroupDescription = dncJSON.dncGroupDescription || '';
            (dncJSON.isActive === 'True') ? this.isActive = 'Active' : this.isActive = 'Inactive';
            this.isRemoved = dncJSON.isRemoved === true;
            this.lastUpdateTime = dncJSON.lastUpdateTime || '';
            createDateFormat = new Date(dncJSON.createDate);
            this.createDate = dncJSON.createDate ? ((createDateFormat.getMonth() + 1) + '/' + createDateFormat.getDate() + '/' + createDateFormat.getFullYear()) : '';
        } else {
            this.totalGroups = 0;
            this.dncGroupId =  0;
            this.dncGroupName = '';
            this.dncGroupDescription = '';
            this.isActive = 'Inactive';
            this.isRemoved = false;
            this.lastUpdateTime = '';
            this.createDate = '';
            this.validRecords = 0;
        }
    }
}
